"use strict";

const $ = require("jquery");

class anchorMenu {
    constructor() {
        const $anchorMenu = $("[data-anchor-menu]");
        const $chapters = $("[data-chapter]");

        if ($anchorMenu.length > 0 && $chapters.length > 0) {
            const $anchorMenu = $(".anchor-menu");
            const $anchorMenuList = $anchorMenu.find("ul");
            let hash = window.location.hash;

            //  Generate menu based on elements
            $chapters.each(function () {
                let $this = $(this);
                let chapterTitle = $this.data("chapter-title");
                let link = $this.attr("id");

                $anchorMenuList.append(
                    `<li><a href="#${link}" class="readspeaker__read">${chapterTitle}</a></li>`
                );
            });

            //  Show menu after loading elements
            $anchorMenu.addClass("show");

            //  Add handler for clicking the menu
            $anchorMenuList.on("click", "a", (event) => {
                event.preventDefault();

                let $this = $(event.currentTarget);
                let target = $this.attr("href");

                this.scrollToTarget(target);
            });

            if (hash && hash.indexOf("#") !== -1) {
                this.scrollToTarget(hash);
            }
        }
    }

    /**
     *
     * @param target
     */
    scrollToTarget(target) {
        let headerHeight = $("#header").height();
        let targetTop = $(target).offset().top;

        App.Globals.$scrollAnimators.animate({
            scrollTop: targetTop - headerHeight - 20,
        });
    }
}

module.exports = anchorMenu;
